import z from "zod";

/**
 * InspecaoObraExecutadoPorSchema
 */

export const InspecaoObraExecutadoPorSchema = z.object({
  realizadoPor: z.coerce.number().default(0),
  idFornecedor: z.number().nullable().default(null),
  funcionarios: z.array(z.number()).nullable().default(null),
}).superRefine((data, ctx) => {
  if (data.realizadoPor === 0 && data.idFornecedor === null) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Este campo deve ser preenchido!',
      path: ['empresa'],
    });
  }
  else if (data.realizadoPor === 1 && (data.funcionarios === null || data.funcionarios.length === 0)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Este campo deve ser preenchido!',
      path: ['funcionarios'],
    });
  }
});

/**
 * InspecaoObraExecutadoPorForm
 */

export type InspecaoObraExecutadoPorForm = z.infer<typeof InspecaoObraExecutadoPorSchema>;